var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "upload-files" },
    [
      _c(
        "b-field",
        [
          _c(
            "b-upload",
            {
              attrs: { multiple: "", "drag-drop": "", expanded: "" },
              model: {
                value: _vm.files,
                callback: function ($$v) {
                  _vm.files = $$v
                },
                expression: "files",
              },
            },
            [
              _c("section", { staticClass: "section" }, [
                _c("div", { staticClass: "content has-text-centered" }, [
                  _c(
                    "p",
                    [
                      _c("b-icon", {
                        attrs: { icon: "upload", size: "is-large" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [_vm._v("Drop your files here or click to upload")]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tags" },
        _vm._l(_vm.files, function (file, index) {
          return _c("span", { key: index, staticClass: "tag is-secondary" }, [
            _vm._v("\n      " + _vm._s(file.name) + "\n      "),
            _c("button", {
              staticClass: "delete is-small",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.deleteDropFile(index)
                },
              },
            }),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "special-instructions" },
        [
          _c("b-message", { attrs: { type: "is-danger", "has-icon": "" } }, [
            _vm._v(
              "\n      Please make sure the following are uploaded: Floor Plans, Section Drawings and Elevations\n    "
            ),
          ]),
          _vm._v(" "),
          _c("b-message", { attrs: { type: "is-info", "has-icon": "" } }, [
            _vm._v(
              "\n      If you have any other information regarding the project please upload with your plans\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }